import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { LOGO_SRC } from '../data/assets';
import { DEMO_URL, SIGN_IN_URL } from '../data/links';
const ROUTES: ReadonlyArray<{
  to: string;
  label: string;
  end?: boolean;
}> = [{
  to: '/',
  label: 'Why',
  end: true
}, {
  to: '/how',
  label: 'How it works'
}, {
  to: '/blog',
  label: 'Blog'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Nav() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();

  // Arriving somewhere new closes the panel; leaving it open would cover the
  // page the tap just navigated to.
  useEffect(() => setOpen(false), [pathname]);
  return <nav className="nav pad" data-id="element-224" data-mp="1uns904oqtjs6">
      <Link className="logo" to="/" data-id="element-225" data-mp="1yq6vqzvj93oq">
        <img src={LOGO_SRC} alt="meetsynthia" data-id="element-226" data-mp="1yr842wl5zc2r" />
      </Link>

      <div className="nav-r" data-id="element-227" data-mp="23p9pho62bnhe">
        <div className="links" data-id="element-228" data-mp="23oi0iw6z0o03">
          {ROUTES.map(r => <NavLink key={r.to} to={r.to} end={r.end} className={({
          isActive
        }) => isActive ? 'on' : undefined} data-id="element-229" data-mp="1y5ynpndl1mw7">
              {r.label}
            </NavLink>)}
        </div>
        <a className="btn" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-230" data-mp="1p5sck85cwz07">
          Book a demo &rarr;
        </a>
        {/* target="_top" so it navigates the whole tab: in an embedded preview a
            plain link loads the app inside the frame instead of leaving it. */}
        <a className="btn" style={{
        background: 'var(--blue)'
      }} href={SIGN_IN_URL} target="_top" rel="noopener" data-id="element-231" data-mp="2cvw3bexg549s">
          Sign in
        </a>
      </div>

      <button type="button" className="navtoggle" aria-expanded={open} aria-controls="nav-panel" onClick={() => setOpen(v => !v)} data-id="element-232" data-mp="2348frp40g7dl">
        {open ? <XIcon size={18} strokeWidth={1.75} aria-hidden="true" data-id="element-233" data-mp="2vs4cuuxhs1aw" /> : <MenuIcon size={18} strokeWidth={1.75} aria-hidden="true" data-id="element-234" data-mp="tx7xqk4k2hqo" />}
        {open ? 'Close' : 'Menu'}
      </button>

      {open && <div className="navpanel" id="nav-panel" data-id="element-235" data-mp="xzl3h8jayfng">
          {ROUTES.map(r => <NavLink key={r.to} to={r.to} end={r.end} className={({
        isActive
      }) => isActive ? 'nl on' : 'nl'} data-id="element-236" data-mp="k63l3r2cr8z0">
              {r.label}
            </NavLink>)}
          <div className="pb" data-id="element-237" data-mp="f70s54znct7e">
            <a className="btn" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-238" data-mp="f8bvx4t3e0yi">
              Book a demo &rarr;
            </a>
            <a className="btn" style={{
          background: 'var(--blue)'
        }} href={SIGN_IN_URL} target="_top" rel="noopener" data-id="element-239" data-mp="19c7ny9hro2v">
              Sign in
            </a>
          </div>
        </div>}
    </nav>;
}